import { uploadToR2 } from "../components/Upload";

/* ----------------------------------
   MEDIA TYPE DETECTION (EXACT)
---------------------------------- */
export const detectMediaType = (file) => {

  if (!file) return "document";

  const name = file.name?.toLowerCase() || "";
  const mime = file.type || "";

  if (
    mime.startsWith("image/") ||
    /\.(jpg|jpeg|png|gif|webp)$/i.test(name)
  ) {
    return (
      mime === "image/gif" ||
      name.endsWith(".gif")
    )
      ? "gif"
      : "image";
  }

  if (
    mime.startsWith("video/") ||
    /\.(mp4|mov|avi|webm)$/i.test(name)
  ) {
    return "video";
  }

  if (
    mime.startsWith("audio/") ||
    /\.(mp3|wav|aac|ogg)$/i.test(name)
  ) {
    return "audio";
  }

  return "document";

};


/* ----------------------------------
   R2 UPLOAD
---------------------------------- */
export const uploadMedia = async (
  file,
  msgIdOrOptions,
  type,
  onProgress
) => {

  const progress =
    typeof onProgress === "function"
      ? onProgress
      : () => {};

  let options;

  if (
    msgIdOrOptions &&
    typeof msgIdOrOptions === "object" &&
    !Array.isArray(msgIdOrOptions)
  ) {

    options = {

      msgId: null,

      statusId: null,

      type: "message",

      ...msgIdOrOptions,

      onProgress:
        typeof msgIdOrOptions.onProgress === "function"
          ? msgIdOrOptions.onProgress
          : progress,

    };

  } else {

    options = {

      msgId: msgIdOrOptions,

      statusId: null,

      type,

      onProgress: progress,

    };

  }

  const uploadResult =
    await uploadToR2(
      file,
      options
    );

  return {

    url:
      uploadResult.url,

    objectKey:
      uploadResult.objectKey,

    encrypted:
      uploadResult.encrypted,

    fileName:
      file.name,

    mimeType:
      file.type,

    fileSize:
      file.size,

  };

};
/* ----------------------------------
   MEDIA CLICK
---------------------------------- */
export const handleMediaClick = (media) => {

  if (!media?.url) return;

  const type =
    media.type ||
    (media.mimeType || "").split("/")[0] ||
    "document";

  // Only documents open a new tab.
  if (type === "document") {

    window.open(
      media.url,
      "_blank",
      "noopener,noreferrer"
    );

  }

};